import React from "react";
import { StyleSheet, View } from "react-native";
import CustomModal from "../../common/general/CustomModal/CustomModal";
import CustomText from "../../common/general/CustomText/CustomText";
import CustomButton from "../../common/general/CustomButton/CustomButton";
import { Trash, Warning } from "@phosphor-icons/react";

const ProjectDeleteModal = ({ visible, onClose, project, onConfirm, loading = false }) => {
  if (!project) return null;

  const projectName = project?.name || "";

  const handleConfirm = () => {
    onConfirm();
  };

  const handleClose = () => {
    onClose();
  };

  return (
    <CustomModal
      visible={visible}
      onRequestClose={handleClose}
      title="Delete Project"
      showCloseButton={false}
      style={styles.modal}
      ariaLabel="Delete project confirmation dialog">
      <View style={styles.content}>
        {/* Warning Section */}
        <View style={styles.warningSection}>
          <View style={styles.warningIcon}>
            <Warning size={32} color="#F04438" weight="fill" />
          </View>
          <View style={styles.warningContent}>
            <CustomText style={styles.warningTitle} text="This action cannot be undone" useTranslationText={false} />
            <CustomText
              style={styles.warningText}
              text={`Are you sure you want to delete "${projectName}"? This will permanently remove the project and all its requirements.`}
              useTranslationText={false}
            />
          </View>
        </View>

        {/* Consequences List */}
        <View style={styles.consequencesSection}>
          <CustomText style={styles.consequencesTitle} text="This will:" useTranslationText={false} />
          <View style={styles.consequencesList}>
            <View style={styles.consequenceItem}>
              <View style={styles.bullet} />
              <CustomText
                style={styles.consequenceText}
                text="Delete the project and all its requirements"
                useTranslationText={false}
              />
            </View>
            <View style={styles.consequenceItem}>
              <View style={styles.bullet} />
              <CustomText
                style={styles.consequenceText}
                text="Remove the project from your portfolio"
                useTranslationText={false}
              />
            </View>
            <View style={styles.consequenceItem}>
              <View style={styles.bullet} />
              <CustomText
                style={styles.consequenceText}
                text="Allow you to submit a new project proposal"
                useTranslationText={false}
              />
            </View>
          </View>
        </View>

        {/* Action Buttons */}
        <View style={styles.buttonContainer}>
          <CustomButton
            text="Cancel"
            size="m"
            styleType="lightStroke"
            onPress={handleClose}
            style={styles.cancelButton}
            disabled={loading}
          />
          <CustomButton
            text={loading ? "Deleting..." : "Delete Project"}
            size="m"
            styleType="danger"
            onPress={handleConfirm}
            disabled={loading}
            loading={loading}
            style={styles.deleteButton}
            leftIcon={!loading && <Trash size={16} color="#ffffff" />}
          />
        </View>
      </View>
    </CustomModal>
  );
};

const styles = StyleSheet.create({
  modal: {
    backgroundColor: "#ffffff",
    maxWidth: 500,
    width: "90%",
    maxHeight: "80%",
  },
  content: {
    paddingTop: 20,
  },
  warningSection: {
    flexDirection: "row",
    alignItems: "flex-start",
    marginBottom: 24,
    padding: 16,
    backgroundColor: "#FEF3F2",
    borderRadius: 8,
    borderLeftWidth: 4,
    borderLeftColor: "#F04438",
  },
  warningIcon: {
    marginRight: 16,
    marginTop: 4,
  },
  warningContent: {
    flex: 1,
  },
  warningTitle: {
    fontSize: 16,
    fontWeight: "600",
    color: "#101828",
    marginBottom: 8,
  },
  warningText: {
    fontSize: 14,
    color: "#667085",
    lineHeight: 20,
  },
  consequencesSection: {
    marginBottom: 32,
    padding: 16,
    backgroundColor: "#F9FAFB",
    borderRadius: 8,
    borderWidth: 1,
    borderColor: "#EAECF0",
  },
  consequencesTitle: {
    fontSize: 14,
    fontWeight: "600",
    color: "#101828",
    marginBottom: 12,
  },
  consequencesList: {
    gap: 8,
  },
  consequenceItem: {
    flexDirection: "row",
    alignItems: "flex-start",
  },
  bullet: {
    width: 6,
    height: 6,
    borderRadius: 3,
    backgroundColor: "#F04438",
    marginTop: 8,
    marginRight: 12,
  },
  consequenceText: {
    fontSize: 14,
    color: "#667085",
    flex: 1,
    lineHeight: 20,
  },
  buttonContainer: {
    flexDirection: "row",
    gap: 12,
    justifyContent: "flex-end",
  },
  cancelButton: {
    flex: 1,
    maxWidth: 120,
  },
  deleteButton: {
    flex: 1,
    maxWidth: 150,
  },
});

export default ProjectDeleteModal;
